<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Sms From Numbers</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="addButton" routerLink="/user/''">
                <ion-icon name="add"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Available Sms From Numbers:
    </ion-list-header>
    
    <ion-list>
        @for (smsNumber of smsNumbers; track $index) {
  <ion-item-sliding>
            <ion-item>
                <ion-label>
                    <strong>{{smsNumber.fromNumber}}:</strong><br />
                    Used By {{smsNumber.numAccounts}} accounts.
                </ion-label>
            </ion-item>
        </ion-item-sliding>
}
    </ion-list>
</ion-content>

<ion-footer>
    <ion-list-header color="secondary" class="ion-text-wrap">
        After Buying a New Phone Number From Twilio, Add It Here:
    </ion-list-header>

    <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>
        <ion-item>
            <ion-label class="ion-text-wrap" position="stacked">Sms From Number</ion-label>
            <ion-input data-test="fromNumber" color="secondary" type="text" name="fromNumber" #fromNumber="ngModel"
                [ngClass]="{ 'is-invalid': f.submitted && fromNumber.invalid }"
                required [(ngModel)]="vm.fromNumber" id="fromNumber" autofocus="true">
            </ion-input>
            @if (submitted && fromNumber.invalid) {
  <div>
                <div class="errorMsg">Sms From Number is required.</div>
            </div>
}
        </ion-item>
    </form>

    <ion-toolbar>
        <ion-button data-test="saveButton" color="primary" expand="full" (click)="onSaveClick(f)">Save</ion-button>
    </ion-toolbar>
</ion-footer>